import { FC } from 'react'

import { ButtonApp, ModalApp, ClipboardItem } from '@/components'
import { MonitorConfig as GroupMonitorConfig } from '@/models/group'
import { MonitorConfig as StoreMonitorConfig } from '@/models/store'

interface ConfigItem {
  name: string
  action: string
  value: string
}

interface MonitoringHintModalProps {
  isOpen: boolean
  monitorConfigDefinitionItems: ConfigItem[]
  monitorConfigExample: GroupMonitorConfig | StoreMonitorConfig
  handleCloseModal(): void
}

const MonitoringHintModal: FC<MonitoringHintModalProps> = ({
  isOpen,
  monitorConfigDefinitionItems,
  monitorConfigExample,
  handleCloseModal,
}) => (
  <ModalApp
    isOpenModal={isOpen}
    handleCloseModal={handleCloseModal}
    title="Admin Hints"
    maxHeight="xs:max-h-[820px] md:max-h-[800px]"
    maxWidth="xs:max-w-[340px] md:max-w-[764px]"
  >
    <div className="w-full flex flex-col min-h-0 grow max-h-[70vh]">
      <div className="flex flex-col p-8 gap-4 grow overflow-auto w-full">
        <div className="w-full shrink-0 h-fit border rounded-md overflow-hidden border-gray-200">
          <table className="w-full text-left text-sm">
            <thead className="text-gray-400 border-b border-gray-200">
              <tr>
                <th className="font-normal p-4 rounded-tl-md">Name</th>
                <th className="font-normal p-4">Action</th>
                <th className="font-normal p-4">Value</th>
              </tr>
            </thead>
            <tbody>
              {monitorConfigDefinitionItems.map(({ name, action, value }, index) => (
                <tr
                  key={index}
                  className="[&:not(:last-child)]:border-b border-gray-200 text-gray-500"
                >
                  <td className="min-w-32 p-4">{name}</td>
                  <td className="p-4">{action}</td>
                  <td className="p-4">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-gray-800 -mb-2">Example</div>
        <ClipboardItem headless value={JSON.stringify(monitorConfigExample, null, 2)}>
          {({ onClick, clipboardIcon }) => (
            <div className="relative">
              <pre className="shrink-0 rounded-lg border border-gray-100 p-6 text-gray-400 text-sm overflow-x-auto">
                {JSON.stringify(monitorConfigExample, null, 2)}
              </pre>
              <button className="absolute top-4 right-4" onClick={onClick}>
                {clipboardIcon}
              </button>
            </div>
          )}
        </ClipboardItem>
      </div>
      <div className="shrink-0 flex justify-end w-full py-6 px-8 border-t border-[#F0F2F7]">
        <ButtonApp
          handleClick={handleCloseModal}
          isPrimary={false}
          width="md:min-w-[160px] w-fit"
          className="h-12"
        >
          Close
        </ButtonApp>
      </div>
    </div>
  </ModalApp>
)

export { MonitoringHintModal }
